import {
  SectionContainer,
  VectorWrapper,
  VectorContainer,
  StyledVector,
  Title,
  Paragraph,
  ExtraContent,
  ContentWrapper,
} from './banner.style';

import Vector1 from '../../assets/images/Vector1.svg';
import Vector2 from '../../assets/images/Vector2.svg';
import Vector3 from '../../assets/images/Vector3.svg';
import Vector4 from '../../assets/images/Vector4.svg';
import Vector5 from '../../assets/images/Vector5.svg';

import Colored1 from '../../assets/images/Colored1.svg';
import Colored2 from '../../assets/images/Colored2.svg';
import Colored3 from '../../assets/images/Colored3.svg';
import Colored4 from '../../assets/images/Colored4.svg';
import Colored5 from '../../assets/images/Colored5.svg';

const Banner = ({ id, title, paragraph, children, isHome = false }) => {
  if (isHome) {
    return (
      <SectionContainer id={id} isHome>
        <VectorWrapper
          isHome
          style={{
            transform: 'scale(0.7)',
            transformOrigin: 'center',
          }}
        >
          <VectorContainer
            style={{
              width: '123px',
              height: '188px',
              top: '50%',
              left: '50%',
              transform: 'translate(-120%, -80%)',
            }}
          >
            <StyledVector src={Vector1} alt="Vector 1" className="default" />
            <StyledVector src={Colored1} alt="Colored 1" className="hovered" />
          </VectorContainer>

          <VectorContainer
            style={{
              width: '70px',
              height: '70px',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -295%)',
            }}
          >
            <StyledVector src={Vector2} alt="Vector 2" className="default" />
            <StyledVector src={Colored2} alt="Colored 2" className="hovered" />
          </VectorContainer>

          <VectorContainer
            style={{
              width: '123px',
              height: '188px',
              top: '50%',
              left: '50%',
              transform: 'translate(20%, -80%)',
            }}
          >
            <StyledVector src={Vector3} alt="Vector 3" className="default" />
            <StyledVector src={Colored3} alt="Colored 3" className="hovered" />
          </VectorContainer>

          <VectorContainer
            style={{
              width: '70px',
              height: '70px',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, 32%)',
            }}
          >
            <StyledVector src={Vector4} alt="Vector 4" className="default" />
            <StyledVector src={Colored4} alt="Colored 4" className="hovered" />
          </VectorContainer>

          <VectorContainer
            style={{
              width: '70px',
              height: '70px',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -130%)',
            }}
          >
            <StyledVector src={Vector5} alt="Vector 5" className="default" />
            <StyledVector src={Colored5} alt="Colored 5" className="hovered" />
          </VectorContainer>
        </VectorWrapper>

        <ContentWrapper>
          <Title isHome>{title}</Title>
          <Paragraph isHome>{paragraph}</Paragraph>
          {children && <ExtraContent>{children}</ExtraContent>}
        </ContentWrapper>
      </SectionContainer>
    );
  }

  return (
    <SectionContainer id={id}>
      <VectorWrapper>
        <VectorContainer
          style={{
            width: '123px',
            height: '188px',
            top: '50%',
            left: '50%',
            transform: 'translate(-120%, -80%)',
          }}
        >
          <StyledVector src={Vector1} alt="Vector 1" className="default" />
          <StyledVector src={Colored1} alt="Colored 1" className="hovered" />
        </VectorContainer>
        <VectorContainer
          style={{
            width: '70px',
            height: '70px',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -295%)',
          }}
        >
          <StyledVector src={Vector2} alt="Vector 2" className="default" />
          <StyledVector src={Colored2} alt="Colored 2" className="hovered" />
        </VectorContainer>
        <VectorContainer
          style={{
            width: '123px',
            height: '188px',
            top: '50%',
            left: '50%',
            transform: 'translate(20%, -80%)',
          }}
        >
          <StyledVector src={Vector3} alt="Vector 3" className="default" />
          <StyledVector src={Colored3} alt="Colored 3" className="hovered" />
        </VectorContainer>
        <VectorContainer
          style={{
            width: '70px',
            height: '70px',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, 32%)',
          }}
        >
          <StyledVector src={Vector4} alt="Vector 4" className="default" />
          <StyledVector src={Colored4} alt="Colored 4" className="hovered" />
        </VectorContainer>
        <VectorContainer
          style={{
            width: '70px',
            height: '70px',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -130%)',
          }}
        >
          <StyledVector src={Vector5} alt="Vector 5" className="default" />
          <StyledVector src={Colored5} alt="Colored 5" className="hovered" />
        </VectorContainer>
        <Title>{title}</Title>
        <Paragraph>{paragraph}</Paragraph>
      </VectorWrapper>
      {children && (
        <div style={{ marginTop: '0', textAlign: 'center' }}>{children}</div>
      )}
    </SectionContainer>
  );
};

export default Banner;
